import React from "react";
import Modal from "react-responsive-modal";
import { Button, Label, Input } from "@revvsales/components";

class ManageColumnsPopup extends React.Component {
  state = {
    manageColumns: [...this.props.columns],
  };

  _returnTitle = () => {
    const headers = ["Columns", "Visible"];
    return headers.map(header => (
      <div className="revvtable-mngcols-header-title" key={header}>
        {header}
      </div>
    ));
  };

  _updateColumnFlag = (columnID, checkedStats) => {
    const { manageColumns } = this.state;
    manageColumns[columnID].show = !checkedStats;
    this.setState({
      manageColumns,
    });
  };

  _returnColumnList = () => {
    const { manageColumns } = this.state;
    return manageColumns.map(column => (
      <div className="revvtable-mngcols-row" key={column.id}>
        <div className="revvtable-mngcols-row-roles">{`${column.name}`}</div>
        <div
          className="revvtable-mngcols-row-roles"
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}>
          <Label
            className="revv-inp-container is-switch"
            data-test="input-revv-inp-container-label"
            htmlFor={column.id}>
            <span
              className="revv-inp-hiddenwrapper"
              data-test="input-revv-inp-hiddenwrapper">
              <Input
                data-test="input-revv-inp-hiddenwrapper-input"
                type="checkbox"
                checked={column.show}
                onChange={() => this._updateColumnFlag(column.id, column.show)}
              />
            </span>
          </Label>
        </div>
      </div>
    ));
  };

  _submit = () => {
    const hiddenColumns = [];
    const newManageColumns = this.state.manageColumns.map(col => {
      if (col.show === false) {
        hiddenColumns.push(col.id);
      }
      return col;
    });
    this.props.setMngColsData(hiddenColumns, newManageColumns);
    this.props.closePopup();
  };

  render() {
    return (
      <Modal open onClose={this.props.closePopup} closeOnOverlayClick={false}>
        <div className="revv-modal-content">
          <div className="revv-modal-contenttitle">
            Manage columns visibility
            <div className="revvtable-mngcols-description">
              You can manage the visibility of the columns
            </div>
          </div>
          <div className="revvtable-mngcols-header doc-column-management">
            {this._returnTitle()}
          </div>
          <div className="revvtable-mngcols-list doc-column-management">
            <span>{this._returnColumnList()}</span>
          </div>
          <div className="revv-modal-footer">
            <div className="revv-modal-footerbtns">
              <Button
                className="btn-transparent"
                onClick={() => this.props.closePopup()}
                data-test="managecolumnspopup-discard-btn">
                Discard
              </Button>
              <Button
                onClick={this._submit}
                data-test="managecolumnspopup-save-btn">
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ManageColumnsPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/ManageColumnsPopup.js